/**
 * Iter-60 — `ResponsiveDataView`.
 *
 * Renders a `<table>` on desktop and a stack of cards on mobile from
 * the SAME `rows` + `columns` definition. Zero data-shape change to
 * consumers.
 *
 * Usage:
 *   <ResponsiveDataView
 *     rows={rows}
 *     testId="leads-view"
 *     desktop={() => (
 *       <table>...existing markup...</table>
 *     )}
 *     mobileCard={(row) => <LeadCard lead={row} />}
 *     empty={<div>No leads</div>}
 *   />
 */
import React from "react";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function ResponsiveDataView({
  rows,
  desktop,
  mobileCard,
  empty = null,
  testId = "responsive-data-view",
}) {
  const isMobile = useIsMobile();
  if (isMobile) {
    if (!rows || rows.length === 0) {
      return <div data-testid={`${testId}-empty`}>{empty}</div>;
    }
    return (
      <div data-testid={`${testId}-cards`} className="flex flex-col gap-2">
        {rows.map((row, i) => (
          <React.Fragment key={row?.id ?? i}>
            {mobileCard(row, i)}
          </React.Fragment>
        ))}
      </div>
    );
  }
  return <div data-testid={`${testId}-desktop`}>{desktop()}</div>;
}
